import { useFragment } from '@apollo/client';
import type {
  AccountPlanAndTrialInfoFragment,
  PlanTier,
} from '@frameio/graphql-client/generated';
import { AccountPlanAndTrialInfo } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

type CurrentPlanVersionAndTier = {
  version: number;
  tier: PlanTier;
};

export function useCurrentPlanVersionAndTier():
  | CurrentPlanVersionAndTier
  | undefined {
  const accountId = useActiveAccountId() ?? '';
  const { data } = useFragment<AccountPlanAndTrialInfoFragment>({
    fragment: AccountPlanAndTrialInfo,
    fragmentName: 'AccountPlanAndTrialInfo',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  const version = data?.subscription?.plan?.version;
  const tier = data?.subscription?.plan?.tier;

  if (version && tier) {
    return { version, tier };
  }

  return undefined;
}
